import Vue from 'vue'
        import VueRouter from 'vue-router'
        import Home from '../views/Home.vue'
        import Login from '../views/Login.vue'
        import Register from '../views/Register.vue'
        import Otp from '../views/Otp.vue'
        import store from '../store/index'
        import CreateScript from '../views/CreateScript.vue'
        import CreateElectronicScript from '../views/CreateElectronicScript.vue'
        import PastScript from '../views/PastScript.vue'
        import PastScriptDetails from '../views/PastScriptDetails.vue'
        import PaymentSummary from '../views/PaymentSummary.vue'
        import PatientList from '../views/PatientList.vue'
        import ProfileDetail from '../views/ProfileDetail.vue'
        import ScriptRequests from '../views/ScriptRequests.vue'
        import NotFound from '../components/NotFound.vue'
        import ContactDetails from '../components/ContactDetails.vue'
        import GroupRequestList from "../views/GroupRequestList";
        import GroupRequestDetails from "../views/GroupRequestDetails";
        import RejectedGroupRequestList from "../views/RejectedGroupRequestList";
        import RejectGroupRequestDetails from "../views/RejectGroupRequestDetails";
        import ScriptDetails from "../views/ScriptDetails";
        import PastScriptAppointmentDetails from "../views/PastScriptAppointmentDetails";
        import PrivacyPolicy from "../views/PrivacyPolicy.vue";
        import TermsAndConditions from "../views/TermsAndConditions.vue";
        // import Chat from "../views/Chat"; temporary commented

        Vue.use(VueRouter);

const routes = [
    {
        path: '/home',
        name: 'home',
        component: Home,
        beforeEnter: (to, from, next) => {
            if (store.getters.login.token == null) {
                next('/')
            } else {
                next()
            }
        }
    },
    {
        path: '/about',
        name: 'About',
        component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    },
    {
        path: '/',
        name: 'login',
        component: Login,
        beforeEnter: (to, from, next) => {
            if (store.getters.login.token != null) {
                next('/home')
            } else {
                next()
            }
        }
    },
    {
        path: '/contact-details',
        name: 'contact-details',
        component: ContactDetails
    },
    {
        path: '/privacy-policy',
        name: 'privacy-policy',
        component: PrivacyPolicy
    },
    {
        path: '/terms-and-conditions',
        name: 'terms-and-conditions',
        component: TermsAndConditions
    },
    {
        path: '/register',
        name: 'register',
        component: Register
    },
    {
        path: '/otp',
        name: 'otp',
        component: Otp
    },
    {
        path: '/create-script',
        name: 'create-script',
        component: CreateScript,
        beforeEnter: (to, from, next) => {
            if (store.getters.login.token == null) {
                next('/')
            } else {
                next()
            }
        }
    },
    {
        path: '/create-electronic-script',
        name: 'create-electronic-script',
        component: CreateElectronicScript,
        beforeEnter: (to, from, next) => {
            if (store.getters.login.token == null) {
                next('/')
            } else {
                next()
            }
        }
    },
    {
        path: '/past-script',
        name: 'past-script',
        component: PastScript,
        beforeEnter: (to, from, next) => {
            if (store.getters.login.token == null) {
                next('/')
            } else {
                next()
            }
        }
    },
    {
        path: '/past-script-details/:id',
        name: 'past-script-details',
        component: PastScriptDetails,
        beforeEnter: (to, from, next) => {
            if (store.getters.login.token == null) {
                next('/')
            } else {
                next()
            }
        },
        props: true
    },
    {
        path: '/payment-summary',
        name: 'payment-summary',
        component: PaymentSummary,
        beforeEnter: (to, from, next) => {
            if (store.getters.login.token == null) {
                next('/')
            } else {
                next()
            }
        }
    },
    {
        path: '/patient-list',
        name: 'patient-list',
        component: PatientList,
        beforeEnter: (to, from, next) => {
            if (store.getters.login.token == null) {
                next('/')
            } else {
                next()
            }
        }
    },
    {
        path: '/group-request-list',
        name: 'group-request-list',
        component: GroupRequestList,
        beforeEnter: (to, from, next) => {
            if (store.getters.login.token == null) {
                next('/')
            } else {
                next()
            }
        }
    },
    {
        path: '/group-request-details',
        name: 'group-request-details',
        component: GroupRequestDetails,
        beforeEnter: (to, from, next) => {
            if (store.getters.login.token == null) {
                next('/')
            } else {
                next()
            }
        }
    },
    {
        path: '/past-request-list',
        name: 'past-request-list',
        component: RejectedGroupRequestList,
        beforeEnter: (to, from, next) => {
            if (store.getters.login.token == null) {
                next('/')
            } else {
                next()
            }
        }
    },
    {
        path: '/past-request-details',
        name: 'past-request-details',
        component: RejectGroupRequestDetails,
        beforeEnter: (to, from, next) => {
            if (store.getters.login.token == null) {
                next('/')
            } else {
                next()
            }
        }
    },
    // {
    //     path: '/chat',
    //     name: 'chat',
    //     component: Chat,

    //     beforeEnter: (to, from, next) => {
    //         if(from && from.name){
    //             store.commit("setFromPath",from.name)
    //         }else{
    //             store.commit("setFromPath",localStorage.getItem("fromPath"))
    //         }
           
    //         if (store.getters.login.token == null) {
    //             next('/')
    //         } else {
    //             next()
    //         }
    //     }
    // },
    {
        path: '/profile-detail',
        name: 'profile-detail',
        component: ProfileDetail,
        beforeEnter: (to, from, next) => {
            if (store.getters.login.token == null) {
                next('/')
            } else {
                next()
            }
        }
    },
    {
        path: '/script-requests',
        name: 'script-requests',
        component: ScriptRequests,
        beforeEnter: (to, from, next) => {
            if (store.getters.login.token == null) {
                next('/')
            } else {
                next()
            }
        }
    },
    {
        path: '/script-details',
        name: 'script-details',
        component: ScriptDetails,
        beforeEnter: (to, from, next) => {
            if (store.getters.login.token == null) {
                next('/')
            } else {
                next()
            }
        }
    },
    {
        path: '/past-script-appointment-details/:id',
        name: 'past-script-appointment-details',
        component: PastScriptAppointmentDetails,
        beforeEnter: (to, from, next) => {
            if (store.getters.login.token == null) {
                next('/')
            } else {
                next()
            }
        },
        props: true
    },
    {
        path: '*',
        name: '404',
        component: NotFound
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        }
        return { x: 0, y: 0 }; 
    },
});

export default router
